import { useEffect, useState } from "react";
import { FaMoon, FaSun } from "react-icons/fa";
import "./layout.css";

export default function Header() {
  const [theme, setTheme] = useState("light");

  // Load saved theme
  useEffect(() => {
    const saved = localStorage.getItem("theme") || "light";
    setTheme(saved);
    document.documentElement.setAttribute("data-bs-theme", saved);
  }, []);

  // Toggle theme
  const toggleTheme = () => {
    const next = theme === "light" ? "dark" : "light";
    setTheme(next);
    document.documentElement.setAttribute("data-bs-theme", next);
    localStorage.setItem("theme", next);
  };

  return (
    <header className="app-header">
      <span className="logo">BBM Classes</span>

      <button className="theme-toggle" onClick={toggleTheme}>
        {theme === "light" ? <FaMoon /> : <FaSun />}
      </button>
    </header>
  );
}